import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router} from '@angular/router';
import { CampaignService } from '../campaign.service';


@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {

   constructor(private route: ActivatedRoute, private router: Router,public CS: CampaignService) { }

  ngOnInit(): void {
	  this.CS.current_page=this.route.snapshot.url[0].path;
  }
	toggleTab(newtab){
		this.CS.current_tab=newtab;
		this.router.navigate(['/main']);
		window.scrollTo(0, 0);
	}

}
